import React, { useEffect, useState } from "react";
import "./SBMarketsPage.scss";
import { Runners } from "../../models/EventData";

type pageProps = {
    data: Runners;
    selectedbet: string;
    mainValue?: any;
    marketId?: string;
};

const SBOddsGrid: React.FC<pageProps> = (props) => {

    const { data, selectedbet, mainValue, marketId } = props;
    const [classes, setClasses] = useState<string>('');

    const [currentValue, setCurrentValue] = useState<number>(0);
    const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(null);



    useEffect(() => oddValueChanged(), [mainValue]);

    useEffect(() => {
        const newTimer = setTimeout(() => {
            setClasses("");
        }, 5000);

        setTimer(newTimer);

        return () => {
            if (newTimer) clearTimeout(newTimer);
        };
    }, [classes]);


    const blinkEffect = (newClass: string) => {
        let count = 0;
        const interval = setInterval(() => {
            setClasses((prev) => (prev ? "" : newClass));
            count++;
            if (count >= 6) clearInterval(interval);
        }, 500);

        setTimer(interval as unknown as ReturnType<typeof setTimeout>);
    };

    const oddValueChanged = () => {
        if (timer) clearTimeout(timer);
        const chVal = mainValue;
        if (chVal) {
            const cVal = currentValue;
            setCurrentValue(chVal);
                if (cVal && chVal !== cVal) {
                    let newClass = cVal < chVal ? "runner-up" : "runner-down";
                    blinkEffect(newClass);
                }
        }
    };

    return (
        <>
            <div className={
                selectedbet === marketId + data?.runnerId + data?.runnerName
                    ? `${classes} active-runner-paper`
                    : `${classes} runner-paper`
            }
            >
                <div className="runner">
                     {/* {data?.runnerName} */}
                    {data?.runnerName.length > 20 ? data?.runnerName.slice(0, 20) + ".." : data?.runnerName}
                </div>
                <div className="odds">
                    {
                        Number(mainValue).toFixed(2)
                    }

                </div>
            </div>
        </>
    );
};


export default SBOddsGrid;
